<template>
  <div>
    <CustomerAddressList
      v-if="addresses"
      :addresses="addresses"
      class="mb-4"
      @edit="editAddress"
      @create="addAddress"
    />

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <CustomerAddressForm
          v-if="selectedAddress"
          :address="selectedAddress"
        />
        <template v-else>
          <v-card-title />
          <loading-state
            :loading="true"
          />
        </template>
        <v-card-actions>
          <v-btn
            v-if="selectedAddress && selectedAddress.id"
            color="darken-1"
            flat
            small
            @click="deleteAddress"
          >
            {{ $t('Delete') }}
          </v-btn>

          <v-spacer />
          <v-btn
            color="darken-1"
            flat
            small
            @click="closeAddressDialog"
          >
            {{ $t('Close') }}
          </v-btn>
          <v-btn
            color="primary darken-1"
            flat
            small
            @click="saveAddress"
          >
            {{ $t('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomerAddressList from './CustomerAddressList'
import CustomerAddressForm from './CustomerAddressForm'
import LoadingState from '@/components/LoadingState'
import { pickBy, identity } from 'lodash'

export default {
  name: 'CustomerAddressWidget',

  components: {
    LoadingState,
    CustomerAddressList,
    CustomerAddressForm
  },

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      dialog: false,
      selectedAddress: null,
      addresses: null
    }
  },

  async created () {
    this.addresses = this.customer.addresses
  },

  methods: {
    closeAddressDialog () {
      this.selectedAddress = null
      this.dialog = false
      this.updateAddresses()
    },

    async addAddress () {
      this.selectedAddress = await this.$http.make('address').for(this.customer)
      this.dialog = true
    },

    async editAddress (address) {
      this.dialog = true
      this.selectedAddress = null
      this.selectedAddressId = address.id
      this.selectedAddress = await this.$http.make('customer:address').for(this.customer).find(this.selectedAddressId)
    },
    async saveAddress () {
      await this.selectedAddress.validate()
      if (this.selectedAddress.errors.length) {
        return
      }

      let fullAddress = { ...this.selectedAddress._attributes }
      fullAddress = await pickBy(fullAddress, identity)
      const optionalFields = ['organization', 'telephone']
      await Promise.all(optionalFields.map(field => {
        fullAddress[field] = this.selectedAddress[field]
      }))

      this.selectedAddress = await this.$http.make('address', { ...fullAddress })
      this.processAddress()
    },

    async processAddress () {
      await this.selectedAddress.for(this.customer)
        .save()
        .then(() => {
          this.updateAddresses()
          this.dialog = false
        })
        .catch(e => {
          this.$vuetify.goTo(0)
          this.$toast.error(this.$t(e.message))
        })
    },

    async updateAddresses () {
      this.addresses = await this.$http.make('address').for(this.customer).get()
    },

    async deleteAddress () {
      await this.selectedAddress.for(this.customer).delete()
      this.updateAddresses()
      this.dialog = false
      // TODO - provide support for errors on delete requests - no way to delete the default address
    }
  }
}
</script>
